<template>
	<div class="default-layout" v-if="sysInfo">
		<div class="fixed fixed-top bg-white" style="z-index: 2000;">
			<div class="h110 flex-text">
				<div class="content por flex flex-align-center flex-pack-justify">
					<el-image class="h60" style="width: 216px;" :src="sysInfo.sysLogo[0]" fit="cover"></el-image>
					<div class="pob pob-cover flex-text fwb" style="font-size: 28px;z-index: -1;">{{ sysInfo.sysTitle }}</div>
					<div class="flex-text color-content" v-if="!token">
						<div class="f16 pointer" @click="loginPopType = 0,loginPop = !loginPop">登录</div>
						<div class="bg-info mx10" style="width: 1px;height: 15px;"></div>
						<div class="f16 pointer" @click="loginPopType = 1,loginPop = !loginPop,getCodeImg()">注册</div>
					</div>
					<div class="color-content" v-if="token && userInfo">
						<el-dropdown @command="handleCommand">
							<div class="pointer flex-text">
								<el-image class="block25 round" :src="userInfo.header || require('@/static/avatar.png')" fit="cover"></el-image>
								<div class="ml10 f16">{{ userInfo.nick }}</div>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item class="f15" command="toMyOrder">{{ userInfo.phone }}</el-dropdown-item>
								<el-dropdown-item class="text-right" command="logout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
			<div class="bg-theme flex-text">
				<div class="content flex-text" style="width: 1300px;">
					<!-- <div class="flex-text flex-1" v-for="(item,index) in navs1" :key="index">
						<div class="h40" style="width: 1px;background-color: rgba(255,255,255,.4);" v-if="index != 0"></div>
						<div class="flex-1 h95 flex-text f14 color-white pointer animation" @click="toNavPath(item,index)">
							<div class="fwb f20">{{ item.text }}</div>
							<div class="mx20">
								<div>查可报岗位</div>
								<div>查单位信息</div>
							</div>
							<div class="mx20">
								<div>查选调资质</div>
								<div>查专业目录</div>
							</div>
							<div class="mx20">
								<div>查进面分数</div>
								<div>查选调资讯</div>
							</div>
						</div>
					</div> -->
					<div class="flex-text flex-1">
						<div class="flex-1 h95 flex-text f14 color-white animation">
							<div class="f20">考公大数据</div>
							<div class="mx20">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 1 }" @click="toNavPath({ path: '/check-job' },1)">查可报岗位</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 2 }" @click="toNavPath({ path: '/unit' },2)">查单位信息</div>
							</div>
							<div class="mx20">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 3 }" @click="toNavPath({ path: '/qualification' },3)">查选调资质</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 4 }" @click="toNavPath({ path: '/' },4)">查专业目录</div>
							</div>
							<div class="mx20">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 5 }" @click="toNavPath({ path: '/fraction' },5)">查进面分数</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 6 }" @click="toNavPath({ path: '/consulting' },6)">查选调资讯</div>
							</div>
						</div>
					</div>
					<div class="flex-text flex-1">
						<div class="h40" style="width: 1px;background-color: rgba(255,255,255,.4);"></div>
						<div class="flex-1 h95 flex-text f14 color-white animation">
							<div class="f20">公职类考试规划</div>
							<div class="mx30">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 7 }" @click="toNavPath({ path: '/basicReport' },7)">初级规划报告</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 8 }" @click="toNavPath({ path: '/report' },8)">高阶规划报告</div>
							</div>
						</div>
					</div>
					<div class="flex-text flex-1">
						<div class="h40" style="width: 1px;background-color: rgba(255,255,255,.4);"></div>
						<div class="flex-1 h95 flex-text f14 color-white animation">
							<div class="f20">个人中心</div>
							<div class="mx20">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 9 }" @click="toNavPath({ path: '/student' },9)">学员管理</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 10 }" @click="toNavPath({ path: '/friend' },10)">素材中心</div>
							</div>
							<div class="mx20">
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 11 }" @click="service.visible = !service.visible">客服</div>
								<div class="my15 pointer" :class="{ 'color-yellow fwb': TabCur == 12 }" @click="toNavPath({ path: '/my-order' },12)">我的</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="bg-theme flex-text">
				<div class="content flex-text">
					<div class="flex-text flex-1" v-for="(item,index) in navs" :key="index">
						<div class="h40" style="width: 1px;background-color: rgba(255,255,255,.4);" v-if="index != 0"></div>
						<div class="flex-1 h60 flex-text f16 fwb color-white pointer animation" :class="{ 'f19': index == TabCur }" @click="toNavPath(item,index)">{{ item.text }}</div>
					</div>
				</div>
			</div> -->
		</div>
		<!-- 导航栏占位 -->
		<div style="height: 190px;"></div>
		
		<!-- 页面展示 -->
		<div style="min-height: calc(100vh - 330px);padding: 30px 0;">
			<router-view />
		</div>
		
		<!-- 右侧悬浮 -->
		<div class="bg-white border-radius-10" style="position: fixed;right: 70px;bottom: 240px;box-shadow: 0 0 16px rgba(0,0,0,.1);width: 70px;">
			<div class="flex-text flex-v pointer" style="height: 85px;" @click="toMyOrder()">
				<div class="por">
					<i class="el-icon-files" style="font-size: 28px;"></i>
					<!-- <div class="pob color-white flex-text round block20 f10" style="right: 0;top: 0;background-color: #ff0024;transform: translateX(45%) translateY(-30%);">2</div> -->
				</div>
				<div class="f12 mt3">订单</div>
			</div>
			<div style="height: 1px;width: 60px;background-color: #dddddd;margin: 0 auto;"></div>
			<div class="flex-text flex-v pointer" style="height: 85px;" @click="service.visible = !service.visible">
				<i class="el-icon-service" style="font-size: 28px;"></i>
				<div class="f12 mt3">客服</div>
			</div>
		</div>
		
		<div class="flex-text" style="height: 100px;background-color: #282828;">
			<div class="content flex flex-align-center flex-pack-justify px30" style="color: #ababab;">
				<div class="flex flex-align-start">
					<!-- <el-image class="h60" style="width: 70px;" :src="require('@/static/logo-bottom.png')" fit="cover"></el-image> -->
					<div class="ml20 f12">
						<!-- <div class="f16">蔚来有途</div> -->
						<div class="">Copyright © 2008-2025 {{ domain }} All Rights Reserved</div>
						<!-- <div class="mt5">河北省石家庄市桥西区新石南路156号</div>
						<div class="mt5">邮编：050000</div> -->
						<div class="flex flex-align-center mt5">
							<div>网站备案号：冀ICP备2024066181号</div>
							<!-- <el-image class="block15 ml8" :src="require('@/static/public-security-backup.png')" fit="cover"></el-image> -->
							<!-- <div style="margin-left: 3px;">冀公网安备：100000000000000 号</div> -->
						</div>
					</div>
				</div>
				<div class="flex-text flex-v" v-if="service.img">
					<div class="border-radius-5 flex-text bg-white" style="width: 80px;height: 80px;">
						<el-image class="border-radius-5" style="width: 72px;height: 72px;" :src="service.img" fit="cover"></el-image>
					</div>
					<div class="mt10 f12">联系我们</div>
				</div>
			</div>
		</div>
		
		
		<!-- 登录、注册、忘记密码 -->
		<transition name="el-fade-in-linear">
			<div v-show="loginPop" class="fixed fixed-top hv100" style="background-color: rgba(0,0,0,.4);z-index: 9999;" @click="loginPop = false" @mousewheel.prevent>
				<div class="flex-text login-pop" style="margin-top: 15vh;">
					<div class="bg-white border-radius-15" style="width: 320px;padding: 40px 40px 30px;" @click.stop>
						<!-- 登录弹窗 -->
						<div v-if="loginPopType == 0">
							<div class="color-theme fwb" style="font-size: 24px;">{{ loginModal.type == 0 ? '账号密码登录' : '验证码登录' }}</div>
							<div class="mt25 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/mobile-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" style="margin-left: 15px;" v-model="loginModal.form.mobile" placeholder="请输入手机号"></el-input>
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;" v-if="loginModal.type == 0">
								<el-image class="block18 ml3" :src="require('@/static/password-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" type="password" style="margin-left: 15px;" v-model="loginModal.form.password" placeholder="请输入密码"></el-input>
							</div>
							<div class="" v-else>
								<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
									<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
									<el-input class="flex-1" maxlength="4" style="margin: 0 15px;" v-model="loginModal.form.imgCode" placeholder="请输入图形验证码"></el-input>
									<img class="pointer" style="width: 80px;height: 38px;" :src="codeImg.base64" alt="" @click="getCodeImg()" v-if="codeImg.base64" />
								</div>
								<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
									<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
									<el-input class="flex-1" maxlength="6" style="margin: 0 15px;" v-model="loginModal.form.code" placeholder="请输入验证码"></el-input>
									<el-button class="flex-text" style="width: 90px;height: 34px;padding: 0 !important;" type="primary" :disabled="disabled || !loginModal.form.mobile || !loginModal.form.imgCode" @click="getCode('loginModal')">{{ buttonText }}</el-button>
								</div>
							</div>
							<div class="mt15 flex flex-align-center flex-pack-justify f13 color-info">
								<div class="pointer" v-if="loginModal.type == 0" @click="loginPopType = 2,getCodeImg()">忘记密码?</div>
								<div class="" v-else></div>
								<div class="">没有账号，<span class="color-theme pointer" @click="loginPopType = 1,getCodeImg()">去注册</span></div>
							</div>
							
							<div class="flex-text flex-v" style="margin-top: 30px;">
								<el-button class="f18 bg-theme" style="width: 200px;height: 50px;border-radius: 25px;box-shadow: 0 4px 14px rgba(0,161,255,.4);" type="primary" round :loading="isLoading" @click="login()">登录</el-button>
								<div class="mt25">
									<el-button class="f16 color-theme" style="padding: 0 !important;" type="text" @click="loginModal.type = loginModal.type == 0 ? 1 : 0,loginModal.type == 1 && getCodeImg()">{{ loginModal.type == 0 ? '验证码登录' : '账号密码登录' }}</el-button>
								</div>
							</div>
						</div>
						
						<!-- 注册弹窗 -->
						<div v-if="loginPopType == 1">
							<div class="color-theme fwb" style="font-size: 24px;">手机号快速注册</div>
							<div class="mt25 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/mobile-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" style="margin-left: 15px;" v-model="registerModal.form.mobile" placeholder="请输入手机号"></el-input>
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" maxlength="4" style="margin: 0 15px;" v-model="registerModal.form.imgCode" placeholder="请输入图形验证码"></el-input>
								<img class="pointer" style="width: 80px;height: 38px;" :src="codeImg.base64" alt="" @click="getCodeImg()" v-if="codeImg.base64" />
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" maxlength="6" style="margin: 0 15px;" v-model="registerModal.form.code" placeholder="请输入验证码"></el-input>
								<el-button class="flex-text" style="width: 90px;height: 34px;padding: 0 !important;" type="primary" :disabled="disabled || !registerModal.form.mobile || !registerModal.form.imgCode" @click="getCode('registerModal')">{{ buttonText }}</el-button>
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/password-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" type="password" style="margin-left: 15px;" v-model="registerModal.form.password" placeholder="请输入密码"></el-input>
							</div>
							<div class="mt15 flex flex-align-center flex-pack-justify f13 color-info">
								<div class=""></div>
								<div class="">已有账号，<span class="color-theme pointer" @click="loginPopType = 0">去登录</span></div>
							</div>
							
							<div class="flex-text flex-v" style="margin-top: 30px;">
								<el-button class="f18 bg-theme" style="width: 200px;height: 50px;border-radius: 25px;box-shadow: 0 4px 14px rgba(0,161,255,.4);" type="primary" round :loading="isLoading" @click="register()">注册</el-button>
							</div>
						</div>
						
						<!-- 忘记密码弹窗 -->
						<div v-if="loginPopType == 2">
							<div class="color-theme fwb" style="font-size: 24px;">忘记密码</div>
							<div class="mt25 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/mobile-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" style="margin-left: 15px;" v-model="forgetModal.form.mobile" placeholder="请输入手机号"></el-input>
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" maxlength="4" style="margin: 0 15px;" v-model="forgetModal.form.imgCode" placeholder="请输入图形验证码"></el-input>
								<img class="pointer" style="width: 80px;height: 38px;" :src="codeImg.base64" alt="" @click="getCodeImg()" v-if="codeImg.base64" />
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/code-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" maxlength="6" style="margin: 0 15px;" v-model="forgetModal.form.code" placeholder="请输入验证码"></el-input>
								<el-button class="flex-text" style="width: 90px;height: 34px;padding: 0 !important;" type="primary" :disabled="disabled || !forgetModal.form.mobile || !forgetModal.form.imgCode" @click="getCode('forgetModal')">{{ buttonText }}</el-button>
							</div>
							<div class="mt10 h50 flex-text" style="border-bottom: 1px solid #ededed;">
								<el-image class="block18 ml3" :src="require('@/static/password-icon.png')" fit="cover"></el-image>
								<el-input class="flex-1" type="password" style="margin-left: 15px;" v-model="forgetModal.form.password" placeholder="请输入新密码"></el-input>
							</div>
							<div class="mt15 flex flex-align-center flex-pack-justify f13 color-info">
								<div class=""></div>
								<div class="">已有账号，<span class="color-theme pointer" @click="loginPopType = 0">去登录</span></div>
							</div>
							
							<div class="flex-text flex-v" style="margin-top: 30px;">
								<el-button class="f18 bg-theme" style="width: 200px;height: 50px;border-radius: 25px;box-shadow: 0 4px 14px rgba(0,161,255,.4);" type="primary" round :loading="isLoading" @click="submit()">提交</el-button>
							</div>
						</div>
						
						<div class="mt30 flex-text">
							<i class="el-icon-success pointer f16" :class="isAgree?'color-theme':'color-disabled'" @click="isAgree = !isAgree"></i>
							<div class="f13 ml10" style="color: #cccccc !important;">我已阅读并同意</div>
							<div class="color-theme f13 pointer" @click="treaty.type = 0,treaty.visible = !treaty.visible">《用户协议》</div>
							<div class="f13" style="color: #cccccc !important;">和</div>
							<div class="color-theme f13 pointer" @click="treaty.type = 1,treaty.visible = !treaty.visible">《隐私政策》</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		
		<!-- 客服弹窗 -->
		<transition name="el-fade-in-linear">
			<div v-show="service.visible" class="fixed fixed-top hv100" style="background-color: rgba(0,0,0,.4);z-index: 9999;" @click="service.visible = false" @mousewheel.prevent>
				<div class="flex-text login-pop" style="margin-top: 200px;">
					<div class="bg-white border-radius-15" style="width: 390px;padding: 60px 35px 80px;" @click.stop>
						<div class="f18 fwb text-center">{{ vipPermissions ? '该功能需开通VIP权限才可使用，请联系客服开通' : sysInfo.kf }}</div>
						<div class="flex-text" style="margin-top: 55px;">
							<el-image style="width: 270px;height: 270px;" :src="sysInfo.kfImg[0]" fit="cover"></el-image>
						</div>
					</div>
				</div>
			</div>
		</transition>
		
		<!-- 用户协议 & 隐私政策 -->
		<transition name="el-fade-in-linear">
			<div v-show="treaty.visible" class="fixed fixed-top hv100 bg-white" style="z-index: 9999;padding: 30px;overflow-y: auto;" @click="treaty.visible = false">
				<div class="text-center f18 fwb" style="line-height: 26px;">{{ treaty.type == 0 ? '用户协议' : '隐私政策' }}</div>
				<div class="mt20 rich-text" v-html="sysInfo.agreement" v-if="treaty.type == 0"></div>
				<div class="mt20 rich-text" v-html="sysInfo.privacy" v-else></div>
			</div>
		</transition>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'defaultLayout',
	data(){
		return {
			domain: '',
			
			navs: [
				{ text: '查专业', path: '/' },
				{ text: '查可报考岗位', path: '/check-job' },
				{ text: '中央选调生', path: '/central' },
				{ text: '定向选调生', path: '/targeted' },
				{ text: '普通选调生', path: '/ordinary' },
				{ text: '规划报告定制', path: '/report' }
			],
			navs1: [
				{ text: '公考大数据', path: '/' },
				{ text: '公职类考试规划', path: '/check-job' },
				{ text: '个人中心', path: '/central' },
			],
			TabCur: localStorage.getItem('TabCur') || 4,
			
			vipPermissions: false,  // 是否是展示vip权限，客服二维码
			// 客服
			service: {
				visible: false
			},
			
			loginPop: false,
			loginPopType: null,  // 登录弹窗类型；0：登录弹窗，1：注册弹窗，2：忘记密码
			loginModal: {
				form: {
					mobile: '',
					code: '',
					password: '',
					imgCode: ''
				},
				type: 0  // 0：密码登录，1：验证码登录
			},
			
			registerModal: {
				form: {
					mobile: '',
					code: '',
					password: '',
					imgCode: ''
				}
			},
			
			forgetModal: {
				form: {
					mobile: '',
					code: '',
					password: '',
					imgCode: ''
				}
			},
			
			isAgree: false,
			
			codeImg: {  // 图形验证码  img,uuid
				uuid: '',
				base64: ''
			},
			disabled: false,
			buttonText: '获取验证码',
			countdown: 60, // 倒计时60秒
			timer: null,
			
			treaty: {
				visible: false,
				type: null
			}
		}
	},
	created() {
		this.domain = window.location.hostname
		
		EventBus.$on('show-login', (payload) => {
			if(payload){
				this.loginPopType = 0
				this.loginPop = true
			}
		})
		
		EventBus.$on('router-path', (payload) => {
			// let idx = this.navs.findIndex(v => v.path == payload)
			// this.TabCur = idx == -1 ? null : idx
		})
		
		EventBus.$on('service', (payload) => {
			if(payload) {
				this.vipPermissions = true
				this.service.visible = !this.service.visible
			}
		})

		// 初始化时设置一次
		this.updateTabCurByRoute();
		
		// 监听路由变化，每次路由切换时更新 TabCur
		this.$router.afterEach(() => {
			this.updateTabCurByRoute();
		});
	},
	beforeDestroy() {
		// 记得移除监听
		EventBus.$off('show-login')
		EventBus.$off('router-path')
		EventBus.$off('service')
		this.$router.afterEach(() => {});
	},
	watch: {
		loginPop(n){
			if(!n){
				setTimeout(() => {
					this.loginPopType = null
					this.loginModal.form.mobile = ''
					this.loginModal.form.code = ''
					this.loginModal.form.password = ''
					this.loginModal.type = 0
					this.loginModal.isAgree = false
				}, 300)
			}
		},
		'service.visible': {
			handler(n){
				if(!n) setTimeout(() => this.vipPermissions = false, 300)
			}
		}
	},
	methods: {
		toMyOrder(){
			if(!this.token) return this.loginPopType = 0,this.loginPop = true
			this.TabCur = 12
			if(this.$route.path != '/my-order') this.$router.push('/my-order')
		},
		
		handleCommand(e){
			this[e]()
		},
		// 根据当前路由更新 TabCur
		updateTabCurByRoute() {
		const currentPath = this.$route.path;
		// 定义路由与 TabCur 的映射关系（根据实际导航配置调整）
		const pathMap = {
			'/check-job': 1,
			'/unit': 2,
			'/qualification': 3,
			'/': 4,
			'/fraction': 5,
			'/consulting': 6,
			'/basicReport': 7,
			'/report': 8,
			'/student': 9,
			'/friend': 10,
			'/my-order': 12
		};
		// 更新 TabCur（如果有匹配的路由）
		if (pathMap[currentPath] !== undefined) {
			this.TabCur = pathMap[currentPath];
			localStorage.setItem('TabCur', this.TabCur); // 同步到本地存储
		}
		},
		toNavPath(item,index){
			if(this.$route.path == item.path) return
			if((index == 1 || index == 2 || index == 3 || index == 5 || index == 6 || index == 7 || index == 8 || index == 9 || index == 10 || index == 12) && !this.token) 
				return this.loginPopType = 0,this.loginPop = true
			this.TabCur = index
			localStorage.setItem('TabCur', index);
			this.$router.push(item.path)
		},
		
		async getCodeImg(){
			this.codeImg = {
				uuid: '',
				base64: ''
			}
			this.$http.get('/api/webs/account/captcha', { isAuth: false })
			    .then(response => {
			        let res = response.data
					this.codeImg.uuid = res.uuid
					this.codeImg.base64 = 'data:image/jpeg;base64,' + res.base64
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		async login(){
			let mobile = /^1[3|4|5|6|7|8|9][0-9]{9}$/
			if(!this.loginModal.form.mobile) return this.$message({ message: '请输入手机号', type: 'warning' })
			if(!mobile.test(this.loginModal.form.mobile)) return this.$message({ message: '请输入正确的手机号', type: 'warning' })
			if(!this.loginModal.form.password && this.loginModal.type == 0) return this.$message({ message: '请输入密码', type: 'warning' })
			if(!this.loginModal.form.code && this.loginModal.type == 1) return this.$message({ message: '请输入验证码', type: 'warning' })
			if(!this.isAgree) return this.$message({ message: '请先阅读并同意《用户协议》和《隐私政策》', type: 'warning' })
			this.isLoading = true
			
			let params = {
				phone: this.loginModal.form.mobile, 
			}
			if(this.loginModal.type == 0){
				params.password = this.loginModal.form.password
			}else{
				params.code = this.loginModal.form.code
			}
			let url = this.loginModal.type == 0 ? '/api/webs/account/loginByPassword' : '/api/webs/account/login'
			this.$http.post(url, params, { isAuth: false })
			    .then(response => {
			        let res = response.data
					this.setToken(res.token)
					this.getUser()
					
					this.isLoading = false
					this.loginPop = false
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
		},
		
		async register(){
			let mobile = /^1[3|4|5|6|7|8|9][0-9]{9}$/
			if(!this.registerModal.form.mobile) return this.$message({ message: '请输入手机号', type: 'warning' })
			if(!mobile.test(this.registerModal.form.mobile)) return this.$message({ message: '请输入正确的手机号', type: 'warning' })
			if(!this.registerModal.form.code) return this.$message({ message: '请输入验证码', type: 'warning' })
			if(!this.registerModal.form.password) return this.$message({ message: '请输入密码', type: 'warning' })
			if(!this.isAgree) return this.$message({ message: '请先阅读并同意《用户协议》和《隐私政策》', type: 'warning' })
			this.isLoading = true
			
			let params = {
				phone: this.registerModal.form.mobile,
				code: this.registerModal.form.code,
				password: this.registerModal.form.password
			}
			this.$http.post('/api/webs/account/signin', params, { isAuth: false })
			    .then(response => {
			        let res = response.data
					this.setToken(res.token)
					this.getUser()
					
					this.isLoading = false
					this.loginPop = false
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
		},
		
		async submit(){
			let mobile = /^1[3|4|5|6|7|8|9][0-9]{9}$/
			if(!this.forgetModal.form.mobile) return this.$message({ message: '请输入手机号', type: 'warning' })
			if(!mobile.test(this.forgetModal.form.mobile)) return this.$message({ message: '请输入正确的手机号', type: 'warning' })
			if(!this.forgetModal.form.code) return this.$message({ message: '请输入验证码', type: 'warning' })
			if(!this.forgetModal.form.password) return this.$message({ message: '请输入新密码', type: 'warning' })
			if(!this.isAgree) return this.$message({ message: '请先阅读并同意《用户协议》和《隐私政策》', type: 'warning' })
			this.isLoading = true
			
			let params = {
				phone: this.forgetModal.form.mobile,
				code: this.forgetModal.form.code,
				password: this.forgetModal.form.password
			}
			this.$http.post('/api/webs/account/resetPassword', params, { isAuth: false })
			    .then(response => {
			        let res = response.data
					
					this.isLoading = false
					this.$message({ message: '修改密码成功', type: 'success' })
					this.loginPopType = 0
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
		},
		
		async getCode(e){
			let mobile = /^1[3|4|5|6|7|8|9][0-9]{9}$/
			if(!this[e].form.mobile) return this.$message({ message: '请输入手机号', type: 'warning' })
			if(!mobile.test(this[e].form.mobile)) return this.$message({ message: '请输入正确的手机号', type: 'warning' })
			if(!this[e].form.imgCode) return this.$message({ message: '请输入图形验证码', type: 'warning' })
			
			let params = { 
				phone: this[e].form.mobile, 
				code: this[e].form.imgCode, 
				uuid: this.codeImg.uuid
			}
			this.$http.post('/api/webs/account/phoneCaptcha', params, { isAuth: false })
			    .then(response => {
					if(response.code != 'S000001') return
					
					this.disabled = true;
					this.buttonText = `${this.countdown}s`;
						  
					this.timer = setInterval(() => {
						this.countdown--;
						this.buttonText = `${this.countdown}s`;
								
						if (this.countdown <= 0) {
							clearInterval(this.timer);
							this.disabled = false;
							this.buttonText = '获取验证码';
							this.countdown = 60; // 重置倒计时
						}
					}, 1000);
			    })
			    .catch(error => {
			        console.error(error)
					this.getCodeImg()
			    })
		}
	}
}
</script>

<style>
.login-pop .el-input__inner{
	border: none !important;
	padding: 0 !important;
}
</style>
